import { render, staticRenderFns } from "./ObjetivoResponsavel.vue?vue&type=template&id=0ce1ddd8&scoped=true"
import script from "./ObjetivoResponsavel.vue?vue&type=script&lang=js"
export * from "./ObjetivoResponsavel.vue?vue&type=script&lang=js"
import style0 from "./ObjetivoResponsavel.vue?vue&type=style&index=0&id=0ce1ddd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce1ddd8",
  null
  
)

export default component.exports